__turbopack_context__.v({
  "bordered": "STInput-module__y4mpaG__bordered",
  "dark": "STInput-module__y4mpaG__dark",
  "disabled": "STInput-module__y4mpaG__disabled",
  "error": "STInput-module__y4mpaG__error",
  "errorText": "STInput-module__y4mpaG__errorText",
  "field": "STInput-module__y4mpaG__field",
  "input": "STInput-module__y4mpaG__input",
  "label": "STInput-module__y4mpaG__label",
  "light": "STInput-module__y4mpaG__light",
  "prefix": "STInput-module__y4mpaG__prefix",
  "suffix": "STInput-module__y4mpaG__suffix",
  "wrapper": "STInput-module__y4mpaG__wrapper",
});
